import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, Copy, X } from 'lucide-react';
import toast from 'react-hot-toast';

const LicenseCreatedModal = ({ license, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (license?.licenseKey) {
      const copyKey = async () => {
        try {
          await navigator.clipboard.writeText(license.licenseKey);
          toast.success(t('licences.viewModal.copySuccess'));
        } catch (e) {
          // Silent fail — user can still copy manually
        }
      };
      copyKey();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [license?.licenseKey]);

  if (!license) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(license.licenseKey);
      toast.success(t('licences.viewModal.copySuccess'));
    } catch (e) {
      toast.error(t('errors.serverError'));
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 modal-backdrop" onClick={onClose}>
      <div
        className="modal-content bg-white rounded-xl shadow-xl max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <CheckCircle2 className="w-6 h-6 text-green-500" />
            <h2 className="text-xl font-bold text-gray-900">{t('licences.createdModal.title')}</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <p className="text-sm text-gray-600 mb-4">{t('licences.createdModal.subtitle')}</p>

          <div className="flex items-center gap-2 mb-4">
            <div className="text-2xl font-bold text-gray-900 font-mono bg-gray-50 px-4 py-3 rounded border border-gray-200 flex-1 break-all text-center">
              {license.licenseKey}
            </div>
            <button
              type="button"
              onClick={handleCopy}
              className="btn-secondary flex items-center gap-1 px-3 py-3"
              title={t('licences.viewModal.copySuccess')}
            >
              <Copy className="w-4 h-4" />
            </button>
          </div>

          <p className="text-xs text-gray-500">{t('licences.createdModal.hint')}</p>
        </div>

        <div className="flex justify-end p-6 border-t border-gray-200">
          <button onClick={onClose} className="btn-primary px-4 py-2">
            {t('licences.createdModal.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LicenseCreatedModal;